<div *ngIf="apps?.length > 0" class="more-apps" [class.active]="open">
  <button
    class="more-apps-icon"
    [attr.aria-label]="open ? 'Close more apps launcher' : 'Open more apps launcher'"
    (click)="open = !open">
    <svg-icon src="/assets/shared/src/lib/images/icons/more-apps.svg"></svg-icon>
  </button>
</div>
<div [class.active-triangle]="open"></div>
<div class="apps-container" [class.show-apps-container]="open">
  <ng-container *ngFor="let app of apps">
    <a *ngIf="app?.currentApp" class="app-icon-container" [routerLink]="app?.homepage" (click)="onAppClick(app)">
      <div class="app-icon">
        <svg-icon [src]="app?.icon"></svg-icon>
      </div>
      <div class="app-logo">
        <svg-icon [src]="app?.logo"></svg-icon>
      </div>
    </a>
    <a *ngIf="!app?.currentApp" class="app-icon-container" (click)="onAppClick(app)" [href]="app?.link" target="_blank">
      <div class="app-icon">
        <svg-icon [src]="app?.icon"></svg-icon>
      </div>
      <div class="app-logo">
        <svg-icon [src]="app?.logo"></svg-icon>
      </div>
    </a>
  </ng-container>
</div>
